import config from 'config'
import { authHeader, queryHelper, router } from '../_helpers'
// import FingerprintJS from '@fingerprintjs/fingerprintjs'

export const userService = {
  login,
  logout,
  register,
  authenticate,
  profile,
  avatar,
  wallet,
  balanceHistory
}

function login (phoneNumber) {
  // get device id
  /* ;(async () => {
    // Get the visitor identifier when you need it.
    const fp = await fpPromise
    const result = await fp.get()

    // This is the visitor identifier:
    const visitorId = result.visitorId
    console.log(visitorId)
  })() */

  const requestBody = {
    version: config.clientVersion,
    platform: config.clientPlatform,
    device_uid: `web_${phoneNumber}`,
    phone: phoneNumber
  }

  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(requestBody)
  }

  // TODO /users/authenticate
  return fetch(`${config.apiUrl}/signin`, requestOptions).then(handleResponse)
}

function logout () {
}

function register (user) {
  const requestBody = {
    device: {
      version: config.clientVersion,
      platform: config.clientPlatform,
      device_uid: `web_${user.phone}`
    },
    user: user
  }

  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(requestBody)
  }

  return fetch(`${config.apiUrl}/signup`, requestOptions).then(handleResponse)
}

function authenticate (phoneNumber, code) {
  const requestBody = {
    version: config.clientVersion,
    verification_code: code,
    device_uid: `web_${phoneNumber}`,
    phone: phoneNumber
  }

  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(requestBody)
  }

  return fetch(`${config.apiUrl}/authenticate`, requestOptions).then(handleResponse)
}

function profile (userUuid) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return fetch(`${config.apiUrl}/profile/${userUuid}`, requestOptions).then(handleResponse)
}

function avatar (userUuid) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return fetch(`${config.apiUrl}/avatar/${userUuid}`, requestOptions).then(handleResponse)
}

function wallet () {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return fetch(`${config.apiUrl}/wallet`, requestOptions).then(handleResponse)
}

function balanceHistory (page) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  var url = `${config.apiUrl}/balance_history`
  var queryParams = {
    'page_size': 25,
    'page_num': page
  }

  return fetch(queryHelper(url, queryParams), requestOptions).then(handleResponse)
}

function handleResponse (response) {
  return response.text().then(text => {
    var data
    try {
      data = text && JSON.parse(text)
    } catch (e) {
      data = text
    }
    console.log('handleResponse userS', text)

    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        localStorage.removeItem('user_uuid')
        localStorage.removeItem('tokens')
        if (router.currentRoute.path !== '/login') {
          router.push('/login').catch(() => {})
        }
      }

      const error = {
        status: response.status || (data && data.status) || null,
        error: (data && data.message) || response.statusText
      }
      return Promise.reject(error)
    }

    return data
  })
}



// WEBPACK FOOTER //
// ./src/_services/user.service.js